import { PureComponent } from 'react';
import bindMethods from 'auto-bind';
import PropTypes from 'prop-types';

export default class WebSocket extends PureComponent {
  constructor(props) {
    super(props);

    this.websocket = new window.WebSocket(props.url);
    bindMethods(this);
  }

  componentDidMount() {
    this.createConnection();
  }

  componentWillUnmount() {
    this.websocket.close();
  }

  createConnection() {
    const {
      appId, onMessage, onError, onClose,
    } = this.props;

    this.websocket.onopen = () => this.websocket.send(appId);

    this.websocket.onclose = () => {
      if (typeof onClose === 'function') onClose();
    };

    this.websocket.onerror = () => {
      if (typeof onError === 'function') onError();
    };

    this.websocket.onmessage = ({ data }) => {
      if (typeof onMessage === 'function') onMessage(data);
    };
  }


  render() {
    return null;
  }
}

WebSocket.propTypes = {
  appId: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  onMessage: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  onError: PropTypes.func,
};
